module.exports = __webpack_public_path__ + "static/PersonCleaningWorktop-ff77d64dfcb2ee61941835c0fd353752.jpg";